import React from 'react';
import { Button, Spinner } from 'tuui';
import { OkOIcon } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components';
import { urlValidations } from 'modules/campaigns/config';
import { withIndication } from 'modules/errors';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { QRCode } from '../../QRCode/QRCode';
import { useUrlInputWithValidation } from '../hooks/useUrlInputWithValidation';
import styles from './UrlInputWithValidation.module.scss';

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);

export const UrlInputWithValidation = ({ validations: validationsProp = urlValidations }) => {
    const {
        websiteUrl,
        showSuccessIcon,
        isValidationsRunning,
        indicationData,
        pixelTesterUrl,
        onChange,
        handleGenerateClick,
        onBlur,
        disableQrCodeButton,
    } = useUrlInputWithValidation(validationsProp);

    const { formatMessage } = useIntl();

    return (
        <>
            <OutlineEditableTextWithIndication
                id="url-input"
                value={websiteUrl}
                onChange={onChange}
                onBlur={onBlur}
                className={styles['url-input-item']}
                inputClassName={styles['url-input']}
                placeholder={formatMessage({
                    id: 'pixel.tester.website.url.placeholder',
                    defaultMessage: 'Enter your URL',
                })}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-component={UrlInputWithValidation.name}
                data-metrics-value={`PIXEL_TESTER_URL_INPUT_${websiteUrl}`}
                blurOnEnter
                {...indicationData}
            >
                {showSuccessIcon && (
                    <OkOIcon data-testid="okIcon" className={styles['success-icon']} aria-label="Validated url icon" />
                )}
            </OutlineEditableTextWithIndication>
            {isValidationsRunning && (
                <div className={styles['validation-container']}>
                    <Spinner size={14} className={styles['spinner']} />
                    <FormattedMessage
                        id="pixel.tester.validating.url"
                        className={styles['validation-text']}
                        defaultMessage="Validating URL..."
                    />
                </div>
            )}
            <Button
                className={styles[pixelTesterUrl ? 'test-events-qr-button' : 'test-events-button']}
                id="PIXEL_TESTER_GENERATE_QR_CODE_BTN"
                variant={Button.variant.primary}
                aria-label="Generate QR Code"
                disabled={disableQrCodeButton}
                onClick={handleGenerateClick}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-component={UrlInputWithValidation.name}
                data-metrics-value={`PIXEL_TESTER_GENERATE_QR_CODE_${websiteUrl}`}
            >
                <FormattedMessage id="pixel.tester.website.generate-qr-code.button" defaultMessage="Generate QR Code" />
            </Button>
            {pixelTesterUrl && <QRCode key={pixelTesterUrl} pixelTesterUrl={pixelTesterUrl} />}
        </>
    );
};
